module.exports = __webpack_public_path__ + "img/marriages.97b1e235.png";